import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { UnleashClient } from 'unleash-proxy-client';

import { AppGlobals } from './app.global';

export enum ToggleName {
  ENABLE_ELIGIBILITY_MESSAGES_REDIRECT = "enable-eligibility-messages-redirect",
  ENABLE_EXAM_DELIVERIES_REDIRECT = "enable-exam-deliveries-redirect",
  ENABLE_MANAGE_GLOBAL_ADMINISTRATORS_REDIRECT = "enable-manage-global-administrators-redirect",
  ENABLE_MANAGE_REGIONAL_ADMINISTRATORS_REDIRECT = "enable-manage-regional-administrators-redirect",
  ENABLE_MANAGE_SITE_ADMINISTRATORS_REDIRECT = "enable-manage-site-administrators-redirect",
  ENABLE_GOVERNMENT_IDENTIFICATION_APPROVAL_REDIRECT = "enable-government-identification-approval-redirect",
  ENABLE_MANAGE_COUNTRIES_REDIRECT = "enable-manage-countries-redirect",
  ENABLE_MANAGE_CHAT_IDLE_TIME_REDIRECT = "enable-manage-chat-idle-time-redirect",
  ENABLE_MANAGE_PROCTOR_ALERT_REDIRECT = "enable-manage-proctor-alert-redirect",
  ENABLE_UNIVERSAL_HOURS_OF_OPERATION_REDIRECT = "enable-universal-hours-of-operation-redirect",
  ENABLE_RETENTION_POLICIES_REDIRECT = "enable-retention-policies-redirect",
  ENABLE_CONCURRENT_EXAMS_REDIRECT = "enable-concurrent-exams-redirect",
  ENABLE_PUBLIC_LOCATIONS_REDIRECT = "enable-public-locations-redirect",
  ENABLE_EXAM_OBJECTIVES = "enable-exam-objectives",
}

@Injectable()
export class FeatureFlagService extends UnleashClient {

  constructor(
    private _appGlobals: AppGlobals,
  ) {
    super({
      url: window.location.origin + "/individualexamscheduler/unleash/proxy",
      appName: "individualexamscheduler-ui",
      clientKey: environment.unleash.clientKey,
    })
    this._appGlobals.userInfo.subscribe(({ email }) => {
      this.updateContext({
        userId: email,
      })
    });
  }

  public isEnabled(toggleName: ToggleName): boolean {
    return super.isEnabled(toggleName.valueOf());
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Services/feature-flag.service.ts